import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

// Job Titles
const setjobTitlesSearched = (state, { jobTitlesSearchedData }) => {
  return state.merge({ jobTitlesSearchedData });
};

const setjobTitlesSearchedLoader = (state, { jobTitlesSearchedLoader }) => {
  return state.merge({ jobTitlesSearchedLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_JOB_TITLES_SEARCHED,
    actionFunction: setjobTitlesSearched,
  },
  {
    actionType: ActionTypes.SET_JOB_TITLES_SEARCHED_LOADER_STATUS,
    actionFunction: setjobTitlesSearchedLoader,
  },
];
